import React from 'react';
import styled from 'styled-components';
import {
  backgroundImage,
  backgroundPosition,
  backgroundRepeat,
  backgroundSize,
  borderColor,
  borderRadius,
  borders,
  boxShadow,
  color,
  display,
  flexWrap,
  fontSize,
  height,
  lineHeight,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  opacity,
  overflow,
  space,
  style,
  textAlign,
  width
} from 'styled-system';
import classNames from 'classnames';
import { whiteSpace } from './utils/typography';

import cursor from './utils/cursor';
import flex from './utils/flex';
import grid from './utils/grid';
import position from './utils/position';

const WrappedFlex = styled.div`
  ${backgroundImage};
  ${backgroundPosition};
  ${backgroundRepeat};
  ${borderRadius};
  ${borderColor};
  ${boxShadow};
  ${backgroundSize};
  ${borders};
  ${color};
  ${display};
  ${height};
  ${width};
  ${flexWrap};
  ${overflow};
  ${style({
    prop: 'overflowX'
  })};
  ${style({
    prop: 'overflowY'
  })};
  ${fontSize};
  ${lineHeight};
  ${maxHeight};
  ${maxWidth};
  ${minHeight};
  ${minWidth};
  ${space};
  ${textAlign};
  ${whiteSpace};

  ${cursor};
  ${flex};
  ${grid};
  ${position};
  ${opacity};
`;

/** @type {React.ForwardRefExoticComponent} */
const Flex = React.forwardRef(({ className, runningText, showSkeleton, large, boxRef, ...rest }, ref) => (
  <WrappedFlex
    {...rest}
    ref={ref || boxRef}
    className={classNames(className, {
      'bp4-running-text': runningText,
      'bp4-text-large': large,
      'bp4-skeleton': showSkeleton
    })}
  />
));

/** @type {React.ForwardRefExoticComponent} */
export const FlexColumn = React.forwardRef((props, ref) => {
  const { boxRef } = props;
  return <Flex {...props} flexDirection="column" ref={ref || boxRef} />;
});

Flex.defaultProps = {
  display: 'flex',
  flexDirection: 'row'
};

export default Flex;
